export const LANDPAGE_VARIANTS = {
  nursing: {
    brand: {
      title: "Dra. Heloisa Andrade - HA Saúde e Movimento",
      subtitle: "Enfermagem especializada",
      footerTitle: "HA Saúde e Movimento",
      footerLocation: "Lago Norte, Brasília/DF",
    },
    colors: {
      accent: "#0f8f86",
      accentSoft: "#36b2a8",
      accentSurface: "rgba(15, 143, 134, 0.1)",
      accentBorder: "rgba(15, 143, 134, 0.2)",
      accentShadow: "rgba(15, 143, 134, 0.24)",
      title: "#0b6660",
      subtitle: "#547674",
      text: "#2e5c58",
      footerBackground: "#f2fbfa",
    },
  },
  aesthetics: {
    brand: {
      title: "Dra. Heloisa Andrade - Estética Avançada",
      subtitle: "Tratamentos estéticos",
      footerTitle: "Dra. Heloisa Andrade - Estética Avançada",
      footerLocation: "Lago Norte, Brasília/DF",
    },
    colors: {
      accent: "#7fb59b",
      accentSoft: "#b8dcc8",
      accentSurface: "rgba(127, 181, 155, 0.14)",
      accentBorder: "rgba(127, 181, 155, 0.3)",
      accentShadow: "rgba(127, 181, 155, 0.24)",
      title: "#2f5a47",
      subtitle: "#6d8679",
      text: "#456657",
      footerBackground: "#f2faf5",
    },
  },
};

export const getLandpageVariantTheme = (variant) =>
  LANDPAGE_VARIANTS[variant] || LANDPAGE_VARIANTS.nursing;
